import { createTheme } from '@mui/material/styles';
import { defaultTheme } from './base';

let theme = defaultTheme();

export const flexsteelTheme = createTheme(theme, {
  palette: {
    primary: {
      main: '#908A83'
    }
  }
});